import { UnitOfMeasureEnum } from '@enums/recipe-enums';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { GroupProps } from '@repo/ui/src/types';
import ShoppableIngredient from '@views/RecipeDetailPage/ShoppableIngredient';

interface Props {
  group: GroupProps;
  unitOfMeasure: number;
}

const IngredientList = ({ group, unitOfMeasure }: Props) => {
  return (
    <div key={group.groupKey} className="tw-mt-3">
      <h6 className="tra-text-web-heading-6 tw-text-left tw-mb-0">{group.groupName}</h6>
      <ul className="tw-list-none tw-py-4 tw-pl-0 tw-m-0 tw-grid tw-grid-cols-[auto_1fr] tw-gap-y-4">
        {group.ingredients.map((ingredient, i) => {
          return (
            <>
              <li
                key={`ingredient_measure_${i}`}
                className="tra-text-web-body-s tw-mb-0 tw-pr-2 tw-border-r tw-text-nowrap"
              >
                {unitOfMeasure === UnitOfMeasureEnum.Imperial ? (
                  <>
                    {ingredient?.imperial?.measurementDisplay} {ingredient?.unitOfMeasure}
                  </>
                ) : (
                  <>
                    {ingredient?.metric?.measurementDisplay} {ingredient?.metric?.unitOfMeasure}
                  </>
                )}
              </li>
              {ingredient?.ingredient?.product ? (
                <ShoppableIngredient product={ingredient.ingredient.product} />
              ) : (
                <li
                  key={`ingredient_name_${i}`}
                  itemProp="recipeIngredient"
                  className="tra-text-web-body-l tw-mb-0 tw-pl-2"
                >
                  {ingredient?.ingredient?.link?.link ? (
                    <Anchor
                      className="tw-text-brand-300 tw-underline hover:tw-underline"
                      link={ingredient.ingredient.link.link}
                    >
                      {ingredient?.ingredient?.name}
                    </Anchor>
                  ) : (
                    ingredient?.ingredient?.name
                  )}
                </li>
              )}
            </>
          );
        })}
      </ul>
    </div>
  );
};

export default IngredientList;
